import { ModelAnatomyOrientation } from "./AnatomyOrientationTypes.js";
import { Cmd_none } from "../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { update as update_1 } from "../../Common/InboundOutbound.js";

export function init() {
    return [new ModelAnatomyOrientation(true), Cmd_none()];
}

export function updateInbound(token, msg, model) {
    return [model, Cmd_none(), Cmd_none()];
}

export function updateLocal(token, msg, model) {
    return [new ModelAnatomyOrientation(msg.fields[0]), Cmd_none(), Cmd_none()];
}

export function update(token, msg, model) {
    return update_1(updateLocal, updateInbound, token, msg, model);
}

